import { useMemo } from 'react';

import { usePsfShareAvailableShareActions } from 'src/app/pages/psf/share/shared/hooks';

import { mapButtonConfigs, type ShareActionItem } from './mapButtonConfigs';
import type { ShareChannel } from './types';

export type { ShareChannel };

type UseActionItemsResult = ModelHookResult<{
	first: ShareActionItem | undefined;
	rest: readonly ShareActionItem[];
}>;

export function useShareActions(): UseActionItemsResult {
	const availableShareActions = usePsfShareAvailableShareActions();
	const buttonConfigs = useMemo(() => mapButtonConfigs(availableShareActions), [availableShareActions]);

	if (buttonConfigs.length === 0) {
		return { data: { first: undefined, rest: [] } };
	}

	const [firstItem, ...restItems] = buttonConfigs;

	if (firstItem.channel !== 'copy') {
		return { data: { first: undefined, rest: buttonConfigs } };
	}

	return { data: { first: firstItem, rest: restItems } };
}
